// Callback.js
import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { getAccessToken } from 'helpers/linkedinAuthHelper';
import { getUserToken } from "helpers/authHelper";
import api from "../../api";

const Callback = () => {
  const location = useLocation();
  const history = useHistory();
  
  //console.log('Request Token:',token);
  useEffect(() => {
    const fetchAccessToken = async () => {
      const params = new URLSearchParams(location.search);
      const code = params.get('code');
     // console.log('codes:',code);
      if (code) {
        try {
          const response = await api.get(
            `${process.env.REACT_APP_API_URL}/admin/job/linkedin-access-token/${code}`,
            
          );        

            // Store the access token securely
            if(response.status==200){ 
              saveAccessToken(response.data.access_token);
              setTimeout(() => {
                history.push('/job-list');
              }, 5000);
             
            }
          
           
        } catch (error) {
          console.error('Error fetching access token:', error);
        }
      }
    }; 
    
    const saveAccessToken = async (token) => {  
         
      if (token) {
        let payload={
          access_token:token
        }
        try {
          const response = await api.post(
            `${process.env.REACT_APP_API_URL}/admin/job/save-linkedin-access-token`,
            payload,
          );        

            // Store the access token securely
            if(response.status==200){ 
                          
              history.push('/job-list');
            }
          
           
        } catch (error) {
          console.error('Error fetching access token:', error);
        }
      }
    };
       
    fetchAccessToken();
   
  }, [location, history]);

  return <div>Loading...</div>;
};

export default Callback;